import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';

export default [
  <ShowocaseLayout
    key="/business/showcase/skincare/home"
    exact
    path="/business/showcase/skincare/home"
    component={AsyncPage}
  />,
];
